import { COOKIE_VERSION, Keys, LOCAL_STORAGE_VERSION } from './constants';
import { WebLocalStorage } from './web-local-storage';

export default WebLocalStorage;

export { Keys as StorageKeys, LOCAL_STORAGE_VERSION, COOKIE_VERSION };
